import React from 'react';
import { MdCheck } from 'react-icons/md';
import { Tooltip, Whisper } from 'rsuite';
import styles from './BulkApprovedButton.module.scss';

export interface BulkApprovedButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export const BulkApprovedButton: React.FC<BulkApprovedButtonProps> = ({ onClick, disabled = false, className = '' }) => {
  return (
    <Whisper placement="top" trigger="hover" speaker={<Tooltip>Aprovar itens selecionados</Tooltip>}>
      <button className={`${styles['bulk-approved-button']} ${className}`} onClick={onClick} disabled={disabled} type="button">
        <MdCheck className={styles['bulk-approved-icon']} color="#28a745" />
      </button>
    </Whisper>
  );
};

